import "../../shimmer.css";

const DiscountShimmer = () => {
  return (
    <div className="min-h-screen w-full max-w-[600px] flex flex-col items-center bg-[#F5F5F5]" style={{fontFamily: "'Noto Sans Ethiopic', sans-serif"}}>
      {/* Countdown Timer Shimmer - API driven */}
      <div className="h-[75px] bg-red-500 w-full flex items-end justify-between px-5 text-white pb-3">
        <div className="text-xs font-bold sm:text-base pb-1">ቅናሹ ሊያበቃ</div>
        <div className="text-white flex gap-2 text-lg">
          <div className="flex flex-col gap-2">
            <p className="text-sm text-center font-bold">ቀን</p>
            <div className="border font-bold border-white rounded w-[60px] h-[30px] flex items-center justify-center">
              <span className="inline-block h-4 w-8 animate-pulse-gradient rounded bg-white/30"></span>
            </div>
          </div>
          <div>
            <p className="text-red-500">-</p>
            <div className="font-bold">:</div>
          </div>
          <div className="flex flex-col gap-2">
            <p className="text-sm text-center font-bold">ሰዓት</p>
            <div className="border font-bold border-white rounded w-[60px] h-[30px] flex items-center justify-center">
              <span className="inline-block h-4 w-8 animate-pulse-gradient rounded bg-white/30"></span>
            </div>
          </div>
          <div>
            <p className="text-red-500">-</p>
            <div className="font-bold">:</div>
          </div>
          <div className="flex flex-col gap-2">
            <p className="text-sm text-center font-bold">ደቂቃ</p>
            <div className="border font-bold border-white rounded w-[60px] h-[30px] flex items-center justify-center">
              <span className="inline-block h-4 w-8 animate-pulse-gradient rounded bg-white/30"></span>
            </div>
          </div>
        </div>
        <div className="pb-1 text-xs sm:text-base font-bold">ቀረው!</div>
      </div>
      
      {/* Header Section - Static content, no shimmer needed */}
      <div className="flex flex-col items-center bg-[#664BC7] w-full text-center text-white pt-4 pb-[90px] gap-4 px-5">
        <p className="text-2xl font-bold">🎉 ታላቅ ቅናሽ 🎉</p>
        <p className="font-bold">
          የ15 ቀን ሙከራ ጊዜ ሲጠቀሙ ለነበሩ ደምበኞቻን ብቻ ያደረግን ሲሆን ዛሬውኑ የiChereta አካውንቶን በማደስ
          አዳዲስ ጨረታዎችን በተለያዩ አማራጮች ያግኙ።
        </p>

        <div className="w-full text-start pl-5 border-t border-t-slate-200/20 pt-2">
          <p>የአባልነት ጥቅል ይምረጡ</p>
        </div>
      </div>

      {/* Plans Section Shimmer - Only API-driven content */}
      <div className="flex flex-col gap-4 w-full px-5 -mt-[70px] mb-5">
        {[1, 2, 3].map((index) => (
          <div
            key={index}
            className="w-full rounded border border-green-500 bg-white p-4 flex flex-col gap-3"
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-full border border-gray-500 relative"></div>
                {/* Plan name shimmer - API driven (plan?.name) */}
                <p className="text-lg font-bold">
                  የ<span className="inline-block h-5 w-20 animate-pulse-gradient rounded-md align-middle"></span>
                </p>
              </div>
              {/* Discounted price shimmer - API driven (plan?.price - plan.discount) */}
              <p className="text-lg font-bold">
                <span className="inline-block h-5 w-16 animate-pulse-gradient rounded-md align-middle"></span> ብር
              </p>
            </div>
            <div className="pl-12 flex items-center justify-between">
              <div className="relative flex items-center justify-center">
                {/* Original price shimmer - API driven (plan.price) */}
                <p className="text-lg font-bold">
                  <span className="inline-block h-5 w-14 animate-pulse-gradient rounded-md align-middle"></span> ብር
                </p>
                <div className="w-full absolute h-1 bg-red-500/50"></div>
              </div>
              {/* Discount amount shimmer - API driven (plan.discount) */}
              <p className="font-bold text-sm bg-green-500 rounded-md px-2 py-1 text-white">
                የ <span className="inline-block h-3 w-8 animate-pulse-gradient rounded-md align-middle bg-white/30"></span> ብር ቅናሽ
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Static content - no shimmer needed */}
      <div className="px-5 w-full sticky bottom-0 font-bold">
        <div className="w-full h-12 bg-green-500 rounded-md flex items-center justify-center text-white">
        → ክፍያ ይፈፅሙ ←
        </div>
      </div>

      <div className="mt-8 pt-4 border-t border-t-slate-200 gap-8 flex flex-col">
        <p className="font-bold text-center text-gray-500">ቀልጣፋ የክፍያ አማራጮች</p>
        <div className="h-8 w-full bg-gray-200 rounded-md"></div>
        <p className="text-md mt-3 text-center font-medium">
          ለበለጠ መረጃ{" "}
          <a href="tel:+251955305555" className="text-[#664BC7]">
            0955305555
          </a>{" "}
          ይደውሉ!
        </p>
      </div>
    </div>
  );
};

export default DiscountShimmer;
